export default [
  {
    path: 'M421.71 379.62c-83.61-165-295.18-139.78-341.61 0.65 0 0-6.46 45.53-11.56 92.91v287.75L204.39 888.5V537.28s14.74-167.91 217.28-157.65zM222.38 647.51s223.06 30.77 230.75-197.4c-3.56-214.2 271.41-228.4 346.12-74.35 0 0-194.85 2.56-215.36 164.08 0 0 2.57 199.32-151.27 219.82 0 0-166.65 28.85-210.24-112.15z m385.72-2.63c83.61 165 291.35 137.86 337.78-2.56 0 0 14.12-32.14 15.38-91V263.57L825.41 136v351.22s-14.77 167.91-217.32 157.66z',
    fill: '#1D2088',
  },
]
